import { getEntitiesByFpIdInvestigationsByInvestigationIdActiveSessionOptions } from '@onefootprint/fetch-dashboard';
import { useQuery } from '@tanstack/react-query';

// Resolves an investigation's agent-run chat session id: the live session id while the agent is
// running, the historical id once idle, or `undefined` when the run has no chat. Deliberately does
// NOT load messages — the header menu uses it to decide whether a transcript exists, and having two
// components run the (cache-evicting) messages query for one session flickers the transcript modal.
export const useInvestigationChatSession = (fpId: string, investigationId: string) => {
  const query = useQuery({
    ...getEntitiesByFpIdInvestigationsByInvestigationIdActiveSessionOptions({ path: { fpId, investigationId } }),
    enabled: !!fpId && !!investigationId,
    retry: false,
  });

  const data = query.data;
  const chatSessionId =
    data?.kind === 'active' ? data.sessionId : data?.kind === 'no_active_session' ? data.chatSessionId : undefined;

  return { isLoading: query.isLoading, chatSessionId };
};
